import type Eshop from '@eshop/type/eshop'
import type Rental from '@eshop/type/rental'

import i18n from './i18n'
import css from './index.module.css'
import { unitConvert } from '#/global/helper/i18n'

import { Config } from '#/global/helper/Config'
import { ProductPriceHelper } from '#/global/helper/Product/ProductPriceHelper'

interface Props {
    product: Eshop.Product<'detail' | 'availability' | 'price'> | Rental.Product<'detail' | 'price'>
    showDiscount?: boolean
}

export const ProductLabel = ({ product, showDiscount = true }: Props) => {
    const lang = Config.getLang()
    const t = i18n[lang]

    const labels = () => {
        if (product.type === 'eshop') {
            switch (true) {
                case product.availability.isWhileStockLast:
                    return <div className={css.isWhileStockLast}>{t.stocksLast}</div>
                case product.detail.isFeatured:
                    return <div className={css.isFeatured}>{t.isFeatured}</div>
                case ProductPriceHelper.hasDiscountPromo(product):
                    return <div className={css.discount}>{t.discount}{showDiscount && ` ${ProductPriceHelper.getDiscountPercent(product)} %`}</div>
                case product.detail.isRecommended:
                    return <div className={css.recommended}>{t.recommended}</div>
                case product.detail.isRecent:
                    return <div className={css.isRecent}>{t.isRecent}</div>
                case true:
                    return null
            }
        }
        if (product.type === 'rental') {
            switch (true) {
                case product.detail.isFeatured:
                    return <div className={css.isFeatured}>{t.isFeatured}</div>
                case true:
                    return null
            }
        }
        return null
    }

    return (
        <div className={`r-product-label ${css.labels}`}>
            {labels()}

            {product.type === 'eshop' && product.detail.seasonPointsText && (
                <div className={css.generousSeason}>
                    <img src="https://cdn1.idek.cz/file/plus-white-a6e119fe.svg" width={22} height={22} />
                    <div>{unitConvert(product.detail.seasonPointsText)}</div>
                </div>
            )}
        </div>
    )
}
